






































import  {Component, Prop, Vue ,Watch} from "vue-property-decorator";
import CategoriesSelect from "@/components/inputs/CategoriesSelect.vue";
import draggable from 'vuedraggable'
import LetEditable from "@/components/LetEditable.vue";
import CategoryListingEntity from "@/entity/CategoryListingEntity";

/**
 * <draggable @start="drag = true" @end="drag = false" v-bind="dragOptionsChips" v-model="item">
 <v-chip v-model="item" @mousedown.stop v-bind:key="item">
 {{ item }}
 </v-chip>
 </draggable>
 */

class requestPayload {
    parent_cat_id:number | null = null;
    cat_id:number | any = null;
}
@Component({components:{
        LetEditable,
        CategoriesSelect,draggable
    }})
export default class CategoryAdditionalListing2 extends Vue {
    @Prop({ required:true }) cat_id!:number | null;
    @Prop({}) categories!:any;
    @Watch('cat_id')
    cat_idChanged(value: string, oldValue: string) {
        //console.log("watch cat_id");
        this.get();
    }
    @Watch('additionalItems')
    itemsChanged(value: any, oldValue: any) {
        if(this.ready == false){
            return;
        }
        //console.log("new",value);
        //console.log("old",oldValue);
        if(value.length > oldValue.length){
            //console.log("eklenmis")
            let choosenItem = value[value.length-1];
            if(typeof  choosenItem == "object"){
                choosenItem = choosenItem.cat_id;
            }
            //console.log(choosenItem,value);
            this.data.parent_cat_id = this.cat_id;
            this.data.cat_id = choosenItem;
            this.add();
        }else{
            //console.log("silinmis")
            oldValue.forEach((ov:any)=>{
                if(typeof ov == "object"){
                    ov = ov.cat_id;
                }
                let findVal = value.find((val:any)=> val == ov);
                //console.log({findVal});
                if(!findVal){
                    this.deleteItem(ov);
                    return;
                }
            })
        }
    }
    drag = false;
    dragOptionsChips =  {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
        sort: true,
    }
    additionalItems:CategoryListingEntity[]=[];
    listItems:any=[];
    data:requestPayload = new requestPayload();
    ready:boolean = false;
    async sortItem(item : any,index : number){
        console.log("sortItem",item);
    }
    start(e : any){
        this.drag = true;
        console.log(e,"start");
    }
    end(e : any){
        this.drag = true;
        console.log(e,"end");
    }
    getAdditionalItem(catId : number){
        var item = this.additionalItems.find(v=>v.cat_id == catId)
        if(!item){
            return {}
        }else{
            console.log(item);
            return item;
        }
    }
    async moveItem(e : any){
        var item = e.draggedContext;
        console.log(e);
        //draggedContext
        //futureIndex: 1
        //index: 0
        let res = await this.$http.patch("categoryAdditionalListing/" + item.element.category_listing_id+"?no="+item.index);
        await this.get();
    }
    print(item : any){
        console.log('item',item)
    }
    created(){
        this.ready = false;
        this.listItems = this.categories.filter((category:any)=>category.cat_id != this.cat_id);
        this.get();
    }
    async doEvent(e:Event){
        this.ready = true;
    }
    async get(){
        let categoryLists = await this.$http.get("categoryAdditionalListing/" + this.cat_id);
        this.additionalItems = categoryLists.data;
    }
    async add(){
        try{
            this.data.parent_cat_id = this.cat_id;
            let added = await this.$http.post("categoryAdditionalListing",this.data);
            //this.get();
        }catch (e) {
            alert(e.message);
        }
    }
    async deleteItem(cat_id:string){
        try{
            let deleted = await this.$http.delete("categoryAdditionalListing/"+this.cat_id+"/"+cat_id);
        }catch (e) {
            console.log(e);
            //alert(e.message);
        }
    }

}
